<template>

	<div 
		:class="{'number-total':true, small: donutSize === 'small', clickable: clickable,minimal:minimal, 'no-bottom': noBottom, 'no-top': noTop}" 
		:style="styles['number-total']"
		@click="clickItem"
	>

		<div :class="{ 'label-wrap': true, 'has-tip': tip !== '' }">

			<div :class="{'donut-wrap': true,positive:jumpAnimation>0,negative:jumpAnimation<0,'no-change': jump===0,loading:loading}">

				<div class="svg-wrap">

					<Icon type="ring-spin" class="loading svg" v-if="loading" />

					<div class="svg-wrap-inner">

						<svg>
						  <defs>
						    <linearGradient :id="'total-positive'+n" x1="0" y1="1" x2="1" y2="0">
						      <stop offset="0" stop-color="#f25c30"></stop>
						      <stop offset="1" stop-color="#eca63c"></stop>
						    </linearGradient>
						  </defs>
						  <g fill="none">
						    <circle :cx="circle.x" :cy="circle.y" :r="circle.radius" :stroke="jumpAnimation>0?'url(#total-positive'+n+')':'#394559'" :stroke-width="circle.strokeWidth" fill="transparent"></circle>
						    <circle :cx="circle.x" :cy="circle.y" :r="circle.radius" stroke="#f2f2f2" :stroke-width="circle.strokeWidth" fill="transparent" :stroke-dasharray="circle.circumference + ' ' + circle.circumference" :stroke-dashoffset="circle.offsetStart" class="circle-line" :id="'circle-line'+n">
						    </circle>
						  </g>
						</svg>

						<div class="circle-end-wrap" :id="'circle-end-wrap'+n" v-if="jumpAnimation!==0">

							<span class="circle-end"></span>

						</div>

						<div class="donut-text-wrap">

							<div class="donut-text">

								<span class="donut-percent" :style="[styles['number-total-value'],fontSize(theTotal)]">{{ theTotal }}</span>

								<h2 class="donut-data" v-if="jumpText" v-html="jumpText" />

							</div>

						</div>

					</div>

				</div>

			</div>

			<h3 
				:class="{'number-total-label':true}" 
				:style="[styles['number-total-label']]" 
				v-html="label"
			/>

			<Tip v-if="tip!==''" :styles="{ 'font-size': '12px' }" position="fromCentre"><span>{{ tip }}</span></Tip>

		</div>

	</div>

</template>

<script>
import { computed, onMounted } from 'vue';
import Tip from './../Tip.vue'
import Icon from './../Display/Icon.vue'
export default {
	name: 'NumberTotalDoughnut',
	components: { Tip, Icon },
	props: {
		clickable: {
			type: Boolean,
			default: false
		},
		n :{
			type: Number,
			default: 0
		},
		jump: {
			type: Number,
			default: 0
		},
		jumpLabel: {
			type: String,
			default: ''
		},
		total: {
			type: [Number,String],
			default: 1
		},
		totalColour: {
			type: String
		},
		label: {
			type: String,
			default: ''
		},
		labelColour: {
			type: String
		},
		tip: {
			type: String,
			default: ''
		},
		minimal: {
			type: Boolean,
			default: false
		},
		donutSize: {
			type: String,
			default: 'normal'
		},
		animation: {
			type: Boolean,
			default: true
		},
		noBottom: {
			type: Boolean,
			default: false
		},
		noTop: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	setup(props, { emit }) {
		const jumpAnimation = computed(() => {
			return !props.animation ? 0 : props.jump;
		});

		const jumpText = computed(() => {
			if (props.jumpLabel !== '') return props.jumpLabel;
			return null;
		});

		const circle = computed(() => {
			const c = {};
			c.width = props.donutSize === 'small' ? 80 : 140;
			c.strokeWidth = props.donutSize === 'small' ? 5 : 8;
			c.radius = (c.width / 2) - (c.strokeWidth * 1);
			c.x = c.width / 2;
			c.y = c.width / 2;
			c.circumference = c.radius * 2 * Math.PI;
			c.offsetStart = c.circumference;

			if (jumpAnimation.value !== 0) {
				c.offsetStart = 0;
				c.offset = c.circumference - (100 - Math.abs(props.jump)) / 100 * c.circumference;
			}
			return c;
		});

		const formatNumber = (n) => {
			if (n === null || n === undefined) return '';
			let am = 'K', tot = parseFloat((n.toString()).replace(',', ''));
			
			if (tot >= 1000000) {
				am = 'M';
				tot /= 1000000;
				return tot.toFixed(1) + am;
			} else if (tot >= 1000) {
				tot /= 1000;
				if (parseFloat(tot.toFixed(0)) < parseFloat(tot.toFixed(1))) {
					tot = tot.toFixed(1);
				} else {
					tot = tot.toFixed(0);
				}
				return tot + am;
			} else {
				if ((n.toString()).length > 5) {
					tot = tot.toFixed(2);
				}
			}
			return tot;
		};

		const theTotal = computed(() => {
			if (props.loading) return '...';
			return formatNumber(props.total);
		});

		const styles = computed(() => {
			const styles = {};
			const styleOps = {
				'number-total': {
					bg: 'background-color',
					borderColour: 'border-color'
				},
				'number-total-value': {
					totalColour: 'color'
				},
				'number-total-label': {
					labelColour: 'color'
				},
				'number-total-value-circle': {
					ringColour: 'border-color',
					ringFill: 'background-color'
				}
			};

			Object.keys(styleOps).forEach(selector => {
				if (typeof styles[selector] === 'undefined') {
					styles[selector] = {};
				}
				Object.keys(styleOps[selector]).forEach(item => {
					if (typeof props[item] !== 'undefined') {
						styles[selector][styleOps[selector][item]] = props[item];
					}
				});
			});

			return styles;
		});

		const clickItem = () => {
			emit('clicked');
		};

		const fontSize = (label) => {
			let fs = { fontSize: props.donutSize === 'small' ? '70%' : '100%' };
			const l = label.toString();

			if (l.length > 2) fs.fontSize = (parseInt(fs.fontSize) - 20) + '%';
			if (l.length > 3) fs.fontSize = (parseInt(fs.fontSize) - (props.donutSize === 'small' ? 5 : 10)) + '%';
			if (l.length > 4) fs.fontSize = (parseInt(fs.fontSize) - 10) + '%';
			if (l.length > 5) fs.fontSize = (parseInt(fs.fontSize) - 10) + '%';
			if (l.length > 6) fs.fontSize = (parseInt(fs.fontSize) - 8) + '%';
			if (l.length > 7) fs.fontSize = (parseInt(fs.fontSize) - 4) + '%';
			if (l.length > 8) fs.fontSize = (parseInt(fs.fontSize) - 3) + '%';
			if (l.length > 9) fs.fontSize = (parseInt(fs.fontSize) - 4) + '%';
			
			return fs;
		};

		onMounted(() => {
			setTimeout(() => {
				if (jumpAnimation.value !== 0) {
					const circleLine = document.getElementById('circle-line' + props.n);
					if (circleLine) {
						circleLine.setAttribute('stroke-dashoffset', circle.value.offset);
					}

					const circleEndWrap = document.getElementById('circle-end-wrap' + props.n);
					if (circleEndWrap) {
						if (props.jump > 0) {
							circleEndWrap.setAttribute('style', 'transform:rotate(' + Math.ceil((Math.abs(props.jump) / 100) * 375) + 'deg)');
						} else {
							circleEndWrap.setAttribute('style', 'transform:scaleX(-1) rotate(' + Math.ceil((Math.abs(props.jump) / 100) * 375) + 'deg)');
						}
					}
				}
			}, (props.n + 1) * 300);
		});

		return {
			jumpAnimation,
			jumpText,
			circle,
			theTotal,
			styles,
			clickItem,
			fontSize,
		};
	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';

	.donut-wrap {

	    width: 140px;
	    height: 140px;
	    font-size: 16px;
	    margin: 0 auto;
	    position: relative;

	    .svg-wrap {

			width: 100%;
			padding-top: 100%; /* 1:1 Aspect Ratio */
			position: relative;

			.loading {

				position: absolute;
				top: 0;
				left: 0;

			}

			.svg-wrap-inner {

				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				.vertical-align-parent;
				position: absolute;

				svg {

					width: 100%;
					height: 100%;
					transform: rotate(90deg);

					.circle-line {

						transition: all 1s ease-in-out;

					}

				}

				.circle-end-wrap {

					width: 100%;
					height: 100%;
					position: absolute;
					left: 0;
					top: 0;
					transition: all 1s ease-in-out;
					z-index: 2;

					.circle-end {

						background-color:@darkContrast;
						width: 16px;
						height: 16px;
						.rounded(50%);
						position:absolute;
						bottom: 1px;
					    left: 50%;
					    margin-left: 1px;

					}

				}

			}

	    }

	    &.positive {

	    	.svg-wrap {

	    		.svg-wrap-inner {

	    			svg {

	    				transform: scaleX(-1) rotate(90deg);

	    			}

	    		}

	    	}

	    }

	    &.negative, &.no-change {

	    	.svg-wrap {

	    		.svg-wrap-inner {

	    			.circle-end-wrap {

	    				transform: scaleX(-1);

	    				.circle-end {

	    					background: linear-gradient(180deg, rgba(242,92,48,1) 0%, rgba(236,166,60,1) 66%);
	    					margin-left: 0;

	    				}

	    			}

	    		}

	    	}

	    }

	    .donut-text-wrap {

	    	width: 72%;
	    	height: 72%;
	    	.rounded(50%);
	    	border: 1px solid #ecf0f3;
	    	position: absolute;
    		top: 14%;
    		left: 14%;
    		-webkit-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
			-moz-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
			box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
			.trans;

	    }

		&.loading {

			.donut-text-wrap {

				border: none;

			}

			.svg-wrap {

				.svg-wrap-inner {

					.opacity(0.5);

				}

			}

		}

	    .donut-text {

		    font-family: Arial, Helvetica, sans-serif;
		    fill: #FFF;
		    font-size: 50px;
		    z-index: 2;
		    width: 100%;
		    .vertical-align;
		    top: 52%;

			.donut-data, .donut-percent {

				max-width: 90%;
				margin: 0 auto;
				display: block;
			    text-align: center;
			    color:@darkContrast;
			    font-size: 0.35em;
			    font-weight: 900;
			    line-height: 1.5em;
			}

		    .donut-percent {

			    font-size: 0.5em;
			    line-height: 1em;
			    font-weight: 900;
			    
			}

			.donut-data {

				color: rgb(242,92,48);
				background: -webkit-linear-gradient(rgba(242,92,48,1), rgba(236,166,60,1));
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;

			}

		}

		.donut-ring {

		    stroke: #8e8e8e;

		}

		.donut-segment {

		    transform-origin: center;
		    stroke: #2275BB;

		}

	}
	
	.number-total {

		padding: 20px;
		box-sizing: border-box;
		vertical-align: top;
		font-size: 40px;
		width: 180px;

		&.no-bottom {
			padding-bottom: 0 !important;
			margin-bottom: 0 !important;
		}

		&.no-top {
			padding-top: 0 !important;
			margin-top: 0 !important;
		}

		&.minimal {

			padding-bottom: 0;

			.donut-wrap {

				.donut-text {

					.donut-data {

						background: none;
						-webkit-background-clip: unset;
    					-webkit-text-fill-color: unset;

					}

				}

			}

		}

		&.clickable {

	    	cursor: pointer;

	    	&:hover {

		    	.donut-wrap {

		    		.donut-text-wrap {

		    			-webkit-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.9);
						-moz-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.9);
						box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.9);

		    		}

		    	}

		    }

	    }

		.number-total-label {

			color: #fff;
			padding:0;
			margin:12px 0 0;
			line-height: 1em;
			text-align:inherit;
			font-size:16px;
			color:@darkContrast;

		}

		.label-wrap {

			vertical-align: top;
			text-align: center;
			position: relative;

			&.has-tip {

				position: relative;
				padding-bottom: 25px;

				.tip {

					position: absolute;
					left: 50%;
					bottom: 0;
					margin-left: -11px;

					.tip-label {

						font-size: 12px;

					}

				}

			}

		}

		&.small {

    		padding: 15px 10px;
    		width: 100px;

    		.donut-wrap {

		    	width: 80px;
		    	height: 80px;
		    	font-size: 14px;

		    	.svg-wrap {

		    		.svg-wrap-inner {

		    			.circle-end-wrap {

		    				.circle-end {

		    					width: 8px;
								height: 8px;

		    				}

		    			}

		    		}

		    	}

		    }

	    	.number-total-label {

	    		font-size: 12px;
    			margin-top: 6px;

	    	}

	    }

	}

	@media screen and (min-width: 440px) {

		.number-total {

			margin:0 0 1% 0;

			&.small {

				margin:0 0 0.5% 0;

			}

		}

	}

</style>